module.exports = __webpack_public_path__ + "static/media/sjt2.e7d43336.jpeg";